import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  // Dynamic block: render.php owns the frontend markup; only inner slides persist.
  save: () => <InnerBlocks.Content />,
  icon: {
    foreground: '#0061FE',
    src: (
      // Center slide flanked by two peeking slides + dots — a content slider.
      // Inline fill:none required: `foreground` adds .has-colors whose
      // `fill: currentcolor` overrides the SVG fill attribute.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="6.5" y="4.5" width="11" height="12" rx="1.5" />
        <path d="M3.5 6.5v8M20.5 6.5v8" />
        <circle cx="9" cy="20" r="0.75" />
        <circle cx="12" cy="20" r="0.75" />
        <circle cx="15" cy="20" r="0.75" />
      </svg>
    ),
  },
});
